exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-treatments{max-width:1440px}.clinic-treatments__title{font-size:32px}.clinic-treatments__list table th{font-size:15px;letter-spacing:.3px;color:var(--theme-grey);position:sticky;top:0;z-index:1;background:#fff;border:none;border-bottom:1px solid #e0e0e0}.clinic-treatments__list table__row{cursor:pointer;background-color:transparent;transition:all .2s;border-bottom:1px solid #e0e0e0;border-top:1px solid #e0e0e0}.clinic-treatments__list table__row:hover{background-color:var(--theme-highlight)}.clinic-treatments__list table__row td{font-size:16px;line-height:20px;color:var(--theme-text-color)}", ""]);

// exports
